import Bag from '../assets/BagInterior.png';
import Syringe from '../assets/Syringe.png';
import Oxygen from '../assets/ScubaTank.png';
import Tonometer from '../assets/Tonometer.png';

const useProducts = [
  {
    id: 0,
    name: 'Blood',
    img: Bag,
    description: 'Whole blood, platelets, plasma etc',
  },
  {
    id: 1,
    name: 'Oxygen',
    img: Oxygen,
    description: 'Refill, exchange and drop-off medical oxygen',
  },
  {
    id: 2,
    name: 'Medical Consumables',
    img: Syringe,
    description: 'Syringes, gloves, masks etc',
  },
  {
    id: 3,
    name: 'Medical Equipment',
    img: Tonometer,
    description: 'Repair and purchase of medical equipment',
  },
];

export default useProducts;
